import "./index.css";
import { Router } from "./router/Router";

export function App() {
  return <Router />;
}

export default App;
